import { Message } from "src/modules/communication-protobuf";

export default function createFlashlightManager({
  getIntensityFromState,
  onChange,
  peerToPeerMessenger,
  messenger,
  peerJid
}) {
  function handleVideoFlashlightStateMessage(cameraAndFlashlightState, from) {
    if (from === peerJid) {
      onChange(cameraAndFlashlightState);
    }
  }

  function turnOn() {
    const newState = {
      enabled: true,
      intensity: getIntensityFromState() || -1
    };
    const message = Message.SetVideoFlashlightMessage.create(newState);
    onChange(newState);
    messenger.sendAsEnvelope({
      to: peerJid,
      payload: { message }
    });
  }

  function turnOff() {
    const newState = {
      enabled: false,
      intensity: getIntensityFromState() || -1
    };
    const message = Message.SetVideoFlashlightMessage.create(newState);
    onChange(newState);
    messenger.sendAsEnvelope({
      to: peerJid,
      payload: { message }
    });
  }

  function setIntensity(intensity) {
    const newState = {
      enabled: true,
      intensity
    };
    const message = Message.SetVideoFlashlightMessage.create(newState);
    onChange(newState);
    messenger.sendAsEnvelope({
      to: peerJid,
      payload: { message }
    });
  }

  function destroy() {
    onChange = () => {};
    peerToPeerMessenger.removeListener(
      peerJid,
      Message.CameraAndFlashlightState.name,
      handleVideoFlashlightStateMessage
    );
  }

  peerToPeerMessenger.on(peerJid, Message.CameraAndFlashlightState.name, handleVideoFlashlightStateMessage);

  return {
    turnOn,
    turnOff,
    setIntensity,
    destroy
  };
}
